import { Pipe, PipeTransform } from "@angular/core";
import { DatePipe } from "@angular/common";

@Pipe({
    name: "dateRange",
    standalone: false
})
export class DateRangePipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}
  transform(
    value: { from: Date | string | null; to: Date | string | null } | null | Array<Date | string>,
    format?: string,
    timezone?: string,
    locale?: string
  ): string {
    if (Array.isArray(value)) {
      value = { from: value[0], to: value[1] };
    }
    if (!value || (!value.from && !value.to)) {
      return "-";
    }
    if (!value.from) {
      return `ab ${this.datePipe.transform(value.to, format, timezone, locale)}`;
    }
    if (!value.to) {
      return `bis ${this.datePipe.transform(value.from, format, timezone, locale)}`;
    }
    return `${this.datePipe.transform(value.from, format, timezone, locale)} - ${this.datePipe.transform(
      value.to,
      format,
      timezone,
      locale
    )}`;
  }
}
